import React from 'react';

import { useDispatch } from 'react-redux';

import CustomFieldsTags from 'bundles/apex/custom_fields/filters/tags';
import { changeCustomFieldsFilterGroup } from 'bundles/research/index/store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';
import { useSelector } from 'bundles/research/index/store/hooks';

import type { Filters } from 'bundles/apex/custom_fields/filters/types';

export default function PropertyCustomFieldsTags() {
  const schemas = useSelector(state => state.static.customFields);
  const filters = useSelector(state => state.query.customFieldFilters) || {};
  const dispatch = useDispatch();

  function changeFilter(filter: Partial<Filters>) {
    dispatch(changeCustomFieldsFilterGroup(filter));
    dispatch(delayRetrieveRecords());
  }

  if (!schemas?.length) {
    return null;
  }

  return (
    <CustomFieldsTags
      changeFilter={changeFilter}
      filters={filters}
      schemas={schemas}
    />
  );
}